import React from 'react';

export default function TypewriterText({ text, charDelay = 50, startDelay = 0 }) {
  if (!text) return null;
  return text.split('').map((char, i) => (
    <span
      key={i}
      style={{
        opacity: 0,
        animationName: 'tw-char',
        animationDuration: '1ms',
        animationDelay: `${startDelay + i * charDelay}ms`,
        animationFillMode: 'forwards',
      }}
    >
      {char}
    </span>
  ));
}
